import { render, staticRenderFns } from "./SaleListPageDetail.vue?vue&type=template&id=78e15654&scoped=true&"
import script from "./SaleListPageDetail.vue?vue&type=script&lang=js&"
export * from "./SaleListPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaleListPageDetail.vue?vue&type=style&index=0&id=78e15654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e15654",
  null
  
)

export default component.exports